<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Nota Médica
      <q-space />
      <q-btn flat round color="primary" icon="print" @click="exportarPDF()" />
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-9">
      <q-input filled dense label="Nombre del Paciente" />
    </div>
    <div class="col-3">
      <q-input filled dense label="No. Expediente" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Edad" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Sexo" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Servicio" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Fecha y Hora" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Signos Vitales
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Peso" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Talla" />
    </div>
    <div class="col-4">
      <q-input filled dense label="IMC" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Tensión Arterial" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Frecuencia Cardiaca" />
    </div>
    <div class="col-4"></div>
    <div class="col-4">
      <q-input filled dense label="Temperatura" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Frecuencia Respiratoria" />
    </div>
    <div class="col-4"></div>
    <div class="col-4">
      <q-input filled dense label="Cintura" />
    </div>
    <div class="col-4">
      <q-input filled dense label="Cadera" />
    </div>
    <div class="col-4">
      <q-input filled dense label="ICC" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Antecedentes Heredofamiliares
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense label="Antecedentes Heredofamiliares" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Antecedentes Personales no Patologicos
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense label="Antecedentes Personales no Patologicos" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Antecedentes Ginecoobestetrico
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense label="Antecedentes Ginecoobestetrico" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Padecimiento Actual
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense label="Padecimiento Actual" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Exploración Física
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense label="Exploración Física" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Plan de Acción
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
 
    <div class="col-12">
      <q-input autogrow filled dense :min-rows="2" label="Plan de Acción" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Plan basado en guías practicas clínicas
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input
        autogrow
        filled
        dense
        :min-rows="2"
        label="Plan basado en guías practicas clínicas"
      />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Pronostico
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense :min-rows="2" label="Pronostico" />
    </div>
    <div class="col-12 text-h6 text-primary no-grap row">
      <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
      Diagnóstico de la Consulta
    </div>
    <div class="col-12">
      <q-separator class="bg-primary" />
    </div>
    <div class="col-12">
      <q-input autogrow filled dense :min-rows="2" label="Diagnóstico de la Consulta" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { computed, onBeforeMount } from "vue";
import axios from "axios";
import { generarVisitaDomiciliaria } from "../PDF/VisitaDomiciliariaPDF.js";
import { Notify, useQuasar, QSpinnerFacebook } from "quasar";
const $q = useQuasar();
const store = useStore();

const paciente = computed({
  get: () => store.state.pacienteStore,
  set: (val) => (store.state.pacienteStore = val),
});

async function exportarPDF() {
  await generarVisitaDomiciliaria(paciente.value);
}
</script>
